import React from "react";
import InvoiceForm from "./forms";

// TODO: CHECK_IT
const CorrectInvoice: React.FC = () => <InvoiceForm />;

export default CorrectInvoice;
